import { Head, Link } from '@inertiajs/react'
import EditionSwitcher from '../components/EditionSwitcher'

export default function PublicLayout({ currentEdition, editions, active, title, children }) {
  const base = `/${currentEdition.slug}`
  const tabs = [
    ['classificacoes', 'Classificações'],
    ['calendario', 'Calendário'],
    ['eliminatorias', 'Eliminatórias'],
    ['classificacao-final', 'Classificação Final'],
    ['equipas', 'Equipas'],
    ['galeria', 'Galeria'],
  ]
  const activeLabel = tabs.find(([slug]) => slug === active)?.[1]
  const pageTitle = title || (activeLabel && `${activeLabel} · ${currentEdition.name}`)
  return (
    <div className="page">
      <Head title={pageTitle} />
      <div className="top">
        <div className="crest">
          <img src="/cabreiroscup_logo.png" alt="Cabreiros Cup" />
        </div>
        <div className="wordmark">
          Cabreiros Cup<em>1ª edição · 2026</em>
        </div>
        <div className="when">
          {currentEdition.name}
          <b>{currentEdition.date}</b>
        </div>
      </div>
      <div className="nav">
        {tabs.map(([slug, label]) => (
          <Link key={slug} href={`${base}/${slug}`} className={active === slug ? 'on' : ''}>
            {label}
          </Link>
        ))}
        <EditionSwitcher editions={editions} current={currentEdition} path={active} />
      </div>
      <div className="body">{children}</div>
      <footer className="foot">
        <div className="wm">
          Cabreiros Cup<em>1ª edição · Junho 2026 · Organização S.C. Cabreiros</em>
        </div>
        <div className="credit">
          Desenvolvido por{' '}
          <a href="https://www.linkedin.com/in/pedroagribeiro" target="_blank" rel="noopener noreferrer">
            Pedro Ribeiro
          </a>
        </div>
      </footer>
    </div>
  )
}
